import { z } from "zod";
/** True when the runtime resolves the value as an IANA zone name. */
export function isIanaTimezone(value) {
    try {
        new Intl.DateTimeFormat("en-US", { timeZone: value });
        return true;
    }
    catch {
        return false;
    }
}
const TIMEZONE_MESSAGE = "Must be an IANA time zone, for example America/New_York.";
/** A zone name Postgres can resolve inside an AT TIME ZONE clause. */
export const ianaTimezoneSchema = z.string().refine(isIanaTimezone, TIMEZONE_MESSAGE);
/** The same check, plus the blank string every stored profile reads as unset. */
export const storedIanaTimezoneSchema = z
    .string()
    .refine((value) => value.trim().length === 0 || isIanaTimezone(value), TIMEZONE_MESSAGE);
// The onboarding data blob is read-modify-written wholesale by the clients, so
// this constrains only the two keys that reach an AT TIME ZONE clause and
// passes every other key through untouched.
export const timezoneCheckedProfileData = z.looseObject({
    timezone: storedIanaTimezoneSchema.optional(),
    locationHint: z
        .looseObject({ timezone: storedIanaTimezoneSchema.optional() })
        .nullable()
        .optional(),
});
//# sourceMappingURL=timezone.js.map